<template>
  <el-card>
    <app-breadcrumb :items="items"></app-breadcrumb>

    <h5 v-if="reloadTable==0">
      <i class="el-icon-loading"></i> Espere a que termine de cargar los datos.
    </h5>

    <app-table-paginate
      v-if="reloadTable!=0"
      previewHistory="user-notifications/user/"
      routeDelete="no"
      selection="no"
      :tableQuery="getList"
      :tableColumns="tableColumns"
      :limit="limit"
      :search="true"
    ></app-table-paginate>
  </el-card>
</template>

<script>
import ApiService from "@/common/api.service";
import tablaConPaginador from "@/components/_commons/tablaConPaginador";
import breadcrumb from "@/components/_commons/breadcrumb";

export default {
  name: "historico-de-acceso",
  components: {
    "app-table-paginate": tablaConPaginador,
    "app-breadcrumb": breadcrumb
  },
  created() {
    this.get();
  },
  data() {
    return {
      reloadTable: 0,
      items: [
        {
          path: "/auditoria/",
          label: "auditoria"
        },
        {
          path: "/auditoria/access-history",
          label: "Histórico de accesos"
        }
      ],

      listAPI: false,
      loading: true,
      tableColumns: [
        {
          prop: "name",
          label: "Nombre"
        },
        {
          prop: "last_name",
          label: "Apellidos"
        },
        {
          prop: "departamento",
          label: "Departamento"
        },
        {
          prop: "area",
          label: "Área"
        },
        {
          prop: "instalacion",
          label: "Instalación"
        }
      ],
      searchQuery: "",
      deleterow: false,
      limit: 10,
      tableShow: true
    };
  },
  methods: {
    async get() {
      ApiService.post("auditoria/user-notifications", {
        token: localStorage.getItem("token")
      }).then(response => {
        this.listAPI = response.data;
        this.reloadTable = 1;
      });
    }
  },
  computed: {
    getList() {
      return this.listAPI;
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/components/auditoria/userNotificactions.vue